export default "__VITE_ASSET__DLiwASv7__"